import { useEffect, useState } from "react";

import { Modal } from "../ui/Modal";
import Spinner from "../irisComponent/Spinner";

import { useBookMeetingModalTest } from "../../hooks/useBookMeetingModalTest";

export const BookMeetingModalTest = () => {
  const { isOpen, onClose } = useBookMeetingModalTest();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (isOpen) {
      setIsLoading(true);
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="p-7">
      <div className="mb-4">
        <h3 className="text-white text-2xl font-semibold">Book a Meeting</h3>
        <p className="text-gray-300">
          Schedule a meeting with Ryan by selecting a date and time.
        </p>
      </div>
      <div className="relative flex justify-center">
        {isLoading && (
          <div className="absolute inset-0 flex items-center justify-center bg-black/80 z-10 rounded-lg">
            <Spinner variant="medium-spinner" alignSpin="center-spinner" />
          </div>
        )}

        <iframe
          title="Book a meeting with Ryan"
          src="https://meetings.hubspot.com/ryan-rayner"
          onLoad={() => setIsLoading(false)}
          className="h-[778px] w-[413.5px] md:w-[827px] border-0 self-center md:self-start rounded-lg"
        ></iframe>
      </div>
    </Modal>
  );
};
